const LOCALES = [
  { id: "en", hreflang: "en", htmlLang: "en", ogLocale: "en_US", label: "English" },
  { id: "es", hreflang: "es", htmlLang: "es", ogLocale: "es_ES", label: "Español" },
  { id: "pt-BR", hreflang: "pt-BR", htmlLang: "pt-BR", ogLocale: "pt_BR", label: "Português (Brasil)" },
  { id: "pt-PT", hreflang: "pt-PT", htmlLang: "pt-PT", ogLocale: "pt_PT", label: "Português (Portugal)" },
  { id: "de", hreflang: "de", htmlLang: "de", ogLocale: "de_DE", label: "Deutsch" },
  { id: "it", hreflang: "it", htmlLang: "it", ogLocale: "it_IT", label: "Italiano" },
];

const UI = {
  en: {
    languages: "Languages",
    readAlso: "Read also",
    home: "Back to AviatorTrends",
    related: "More guides",
    sources: "Sources",
    plans: "See plans",
  },
  es: {
    languages: "Idiomas",
    readAlso: "Leer también",
    home: "Volver a AviatorTrends",
    related: "Más guías",
    sources: "Fuentes",
    plans: "Ver planes",
  },
  "pt-BR": {
    languages: "Idiomas",
    readAlso: "Leia também",
    home: "Voltar para a AviatorTrends",
    related: "Mais guias",
    sources: "Fontes",
    plans: "Ver planos",
  },
  "pt-PT": {
    languages: "Idiomas",
    readAlso: "Leia também",
    home: "Voltar à AviatorTrends",
    related: "Mais guias",
    sources: "Fontes",
    plans: "Ver planos",
  },
  de: {
    languages: "Sprachen",
    readAlso: "Außerdem lesen",
    home: "Zurück zu AviatorTrends",
    related: "Weitere Leitfäden",
    sources: "Quellen",
    plans: "Pläne ansehen",
  },
  it: {
    languages: "Lingue",
    readAlso: "Leggi anche",
    home: "Torna ad AviatorTrends",
    related: "Altre guide",
    sources: "Fonti",
    plans: "Vedi i piani",
  },
};

module.exports = { LOCALES, UI };
